import http from "../http";
import Service from "../../Service";

/**
 * @type ProductService
 */
export default class ProductService extends Service {

    load(id) {
        return http.get(`clients/products/${id}`, {
            headers: this.getHeaders()
        });
    }

    create(payload) {
        return http.post(`v2/clients/products`, payload, {
            headers: this.getHeaders(),
        });
    }

    destroy(id) {
        return http.delete(`v2/clients/products/${id}`, {
            headers: this.getHeaders(),
        });
    }

    code_suggestion() {
        return http.get(`v2/clients/products/code-suggestion`, {
            headers: this.getHeaders(),
        });
    }

    update(id, payload) {
        return http.put(`v2/clients/products/${id}`, payload, {
            headers: this.getHeaders(),
        });
    }

    categories() {
        return http.get(`clients/categories`, {
            headers: this.getHeaders(),
        });
    }

    query(params, cancelToken) {
        return http.get(`clients/products/query`, {
            headers: this.getHeaders(),
            params,
            cancelToken,
        });
    }

    summary(params, cancelToken) {
        return http.get(`clients/products/summary`, {
            headers: this.getHeaders(),
            params,
            cancelToken,
        });
    }

    purchase_sources(id) {
        return http.get(`clients/products/${id}/purchase-sources`, {
            headers: this.getHeaders()
        });
    }

    get_products(for_id, page=1, search = null){
        const params = new URLSearchParams({
            page
        });

        if (search) {
            params.append('search', search);
        }
        return http.get(`providers/${for_id}/produtos-fornecedor?${params.toString()}`, {
            headers: this.getHeaders()
        });
    }

    export_products_report(for_id, search = null) {
        const params = new URLSearchParams();
        if (search) {
            params.append('search', search);
        }
        return http.get(
            `providers/${for_id}/produtos-fornecedor/excel?${params.toString()}`,
            {
                headers: this.getHeaders(),
                responseType: "blob",
            }
        );
    }
    
}
